import React from 'react';
import { ProductCode } from '@contracts';
import IconCBD from '@images/icon-cbd.svg';
import IconDiagnosticTampon from '@images/icon-diagnostic-tampon.svg';
import IconLiner from '@images/icon-liner.svg';
import IconPad from '@images/icon-pad.svg';
import IconProviotics from '@images/icon-proviotics.svg';
import IconTampon from '@images/icon-tampon.svg';

interface Props {
  code: string;
}

const ProductItemIcon: React.FC<Props> = ({ code }) => {
  const tamponCodes = ['tampon_box', 'cbdregular', 'cbdsuper', 'nakedsuper', 'nakedregular'];
  const padCodes = ['pads_box', 'r', 's', 'sp', 'pn', 'pnp', 'pr'];

  const renderProductIcon = () => {
    if (tamponCodes.includes(code)) {
      return <IconTampon />;
    }
    if (padCodes.includes(code)) {
      return <IconPad />;
    }
    if (code === ProductCode.VMSEssential) {
      return <IconDiagnosticTampon />;
    }
    if (code === ProductCode.Proviotics) {
      return <IconProviotics />;
    }
    if (code === 'pl') {
      return <IconLiner />;
    }

    return null;
  };

  return renderProductIcon();
};

export default ProductItemIcon;
